<template>
  <div class="problem">
    <nav-bar title="常见问题"></nav-bar>
    <div class="content">
      <div class="top">
        <h1>实名认证常见问题汇总</h1>
        <span>了解以下须知</span>
      </div>
      <div class="item">
        <h2><span>Q1</span> 为什么要进行实名认证？</h2>
        <span
          >A
          完成实名认证可更好的保障您账号安全，与爱好共建安全出行秩序。为了保证实名信息真实，需完成人脸认证。</span
        >
      </div>
      
      <div class="item">
        <h2><span>Q2</span> 实名认证不是我的怎么办？</h2>
        <span>若实名信息有误，你可拨打客服电话进行申诉？</span>
      </div>
      <div class="item">
        <h2><span>Q3</span> 为什么我的人脸识别总是不通过？</h2>
        <span
          >完成实名认证可更好的保障您的账号安全，与爱好共建安全出行秩序。为了保证实名认证信息真实，需要完成人脸认证。</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";

export default {
  name: "problem",
  components: {
    NavBar
  }
};
</script>

<style scoped lang="less">
.problem {
  width: 100%;
  height: 100%;
  background: rgba(247, 247, 247, 1);
  .content {
    background: rgba(255, 255, 255);
    width: 355px;
    margin: 10px auto;
  }
  .top {
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #c3cbcc;
    h1 {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
      margin: 0;
    }
    span {
      display: block;
      margin-top: 6px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(196, 198, 205, 1);
    }
  }
  .item {
    padding: 15px;
    box-sizing: border-box;
    font-size: 0;
    border-bottom: 1px solid #c3cbcc;
    h2 {
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(33, 37, 41, 1);
      margin: 0;
      span {
        width: 33px;
        height: 20px;
        line-height: 20px;
        display: inline-block;
        text-align: center;
        background: rgba(33, 37, 41, 1);
        border-radius: 2px;
      }
    }
    span {
      display: inline-block;
      margin-top: 6px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(158, 160, 165, 1);
    }
  }
}
</style>
